module.exports = __webpack_public_path__ + "img/pr-3.a7a431db.png";